import React, { useContext, useEffect, useState } from 'react';
import {CaptureContext, ModuloContext, SellerContext} from '../context/seller_context';
import '../assets/styles/seller_profile.css';
import faceLogo from "../assets/images/icons/reconocimiento facial_negro.jpg";
import fingerPrintLogo from "../assets/images/icons/reconocimiento dactilar_negro.jpg";
import sellerSuccessful from "../assets/images/icons/ventero_verificado.jpg";
import sellerNotSuccessful from "../assets/images/icons/ventero_sinverificar.jpg";
import {useNavigate} from "react-router-dom";
import {MyContext} from "../context/my_context";
import {SellerData} from "../context/seller_context";

const SellerInfo = () => {
    const sellerContext = useContext(SellerContext);
    const moduloContext = useContext(ModuloContext);
    const captureContext = useContext(CaptureContext);
    const [selectedOption, setSelectedOption] = useState('');
    const navigate = useNavigate();
    const { module } = moduloContext!;
    const { seller, setSeller } = sellerContext!;
    const { hasCapturedImageC } = captureContext!;
    const context = useContext(MyContext);

    if (!context) {
        throw new Error("UserProfile must be used within a MyProvider");
    }

    const { userData } = context;

    useEffect(() => {
        if (!sellerContext || !module?.id || !userData?.token) return;

        const idAssignedSeller = module.id.toString();

        const fetchCombinedData = async () => {

            try {
                // Main or development backend URL
                const apiUrl = process.env.NODE_ENV === 'development'
                    ? `${process.env.REACT_APP_BACK_DEV}/ventero-completo/${idAssignedSeller}`
                    : `${process.env.REACT_APP_BACK_URL}/ventero-completo/${idAssignedSeller}`;

                const mainResponse = await fetchWithFallback(apiUrl, userData.token);
                processResponseData(mainResponse, 'Principal');

            } catch (mainError) {
                console.error("Error en backend principal y/o local:", mainError);
            }
        };

        // Auxiliary method to fetch data with error handling
        const fetchWithFallback = async (url: string, token: string) => {
            const response = await fetch(url, {
                headers: {
                    'x-access': token,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();

            if (!data.success) {
                throw new Error(data.message || 'Error en los datos recibidos');
            }

            return data;
        };

        // Method to process the response data
        const processResponseData = (data: any, source: string) => {

            // console.log(`Datos desde el backend ${source}:`, data);

            const personaData = data.persona?.entities?.persona?.[idAssignedSeller] || {};
            const venteroData = data.ventero?.entities?.ventero?.[idAssignedSeller] || {};

            /* console.log('Detalles:', {
                venteroId: idAssignedSeller,
                personaData,
                venteroData,
                fotoUrl: venteroData.enlace
            });
             */

            const sellerData: SellerData = {
                nombre_completo: `${personaData.nombre1 || ''} ${personaData.apellido1 || ''}`.trim(),
                id_tipo_documento: personaData.idTipoDocumento?.toString() || '',
                documento: personaData.documento || '',
                correo_electronico: personaData.correoElectronico || '',
                actividad: venteroData.actividad || '',
                fecha_vencimiento: venteroData.fechaVencimiento || '',
                numero_resolucion: venteroData.numeroResolucion || '',
                foto_ventero: venteroData.enlace || '',
                telefono: personaData.telefonoCelular || module?.telefonoCelular || null
            };

            setSeller(sellerData);
        };

        fetchCombinedData();

    }, [setSeller]);

    useEffect(() => {
        setSelectedOption("1");
    }, []);

    const formatDate = (fecha: string): string => {
        const date = new Date(fecha);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    // Method to handle option change
    const handleChange = (event: any) => {
        setSelectedOption(event.target.value);
    };

    const handleClick01 = () => {
        navigate('/face_recognition');
    };

    const handleClick02 = () => {
        navigate('/generate_report');
    };

    const handleClick03 = () => {
        navigate('/bluetooth_component_final');
    };

    console.log("hasCapturedImageC", hasCapturedImageC);

    return (
        <div className="seller-info-container" >
            <div className="inner-container">
                <div className="module-container">
                    <div className="seller-container-title">
                    <h2>INFORMACIÓN DEL MODULO</h2>
                    </div>
                    {module ? (
                        <div>
                            <div>
                                <strong>Tipo de Amoblamiento:</strong>
                                <p>Modulo</p>
                            </div>
                            {module.id && (
                                <div>
                                    <strong>Módulo Estacionario:</strong>
                                    <p>{module.id}</p>
                                </div>
                            )}
                            {module.serial_propio && (
                                <div>
                                    <strong>Serial:</strong>
                                    <p>{module.serial_propio}</p>
                                </div>
                            )}
                            {module.id_direccion && (
                                <div>
                                    <strong>Dirección:</strong>
                                    <p>{module.id_direccion}</p>
                                </div>
                            )}
                            {module.barrio && (
                                <div>
                                    <strong>Barrio:</strong>
                                    <p>{module.barrio}</p>
                                </div>
                            )}
                            {module.id_sector_modulo && (
                                <div>
                                    <strong>Comuna:</strong>
                                    <p>{module.id_sector_modulo}</p>
                                </div>
                            )}
                            {module.id_tenencia_propiedad && (
                                <div>
                                    <strong>Identificación Del Ventero Asignado:</strong>
                                    <p>{module.id_tenencia_propiedad}</p>
                                </div>
                            )}
                        </div>
                    ) : (
                        <p>No se encontró información del módulo</p>
                    )}
                </div>

                <div className="seller-container">
                    <div className="seller-container-title">
                        <h2>INFORMACIÓN DEL VENTERO</h2>
                    </div>
                    {seller ? (
                    <div className="seller-container-info">
                        {seller.nombre_completo && (
                            <div>
                                <strong>Nombre y Apellido:</strong>
                                <p>{seller.nombre_completo}</p>
                            </div>
                        )}
                        {seller.id_tipo_documento && (
                            <div>
                                <strong>Tipo de Documento:</strong>
                                <p>{seller.id_tipo_documento == "1" ? 'CC' : 'Otro'}</p>
                            </div>
                        )}
                        {seller.documento && (
                            <div>
                                <strong>Documento:</strong>
                                <p>{seller.documento}</p>
                            </div>
                        )}
                        {seller.actividad && (
                            <div>
                                <strong>Actividad Economica Actual:</strong>
                                <p>{seller.actividad}</p>
                            </div>
                        )}
                        {seller.numero_resolucion && (
                            <div>
                                <strong>Resolución:</strong>
                                <p>{seller.numero_resolucion}</p>
                            </div>
                        )}
                        {seller.fecha_vencimiento && (
                            <div>
                                <strong>Vence:</strong>
                                <p>{formatDate(seller.fecha_vencimiento)}</p>
                            </div>
                        )}
                        {seller.telefono && (
                            <div>
                                <strong>Celular:</strong>
                                <p>{seller.telefono}</p>
                            </div>
                        )}
                    </div>
                    ) : (
                        <p>No se encontraron datos del ventero asociados al modulo</p>
                    )}

                    <div className="validation-container">
                        <div className="icons-options-container">
                            <img className="img-options" src={selectedOption == '1' ? faceLogo : fingerPrintLogo} />
                            <img className="img-responses" src={hasCapturedImageC == true ? sellerSuccessful : sellerNotSuccessful} height="90"/>
                        </div>
                        <div className="options-container">
                            <div>
                                <h4 className="my-options-title">Validar Identidad</h4>
                            </div>
                            <div>
                                <select id="my-select" className="my-select" value={selectedOption} onChange={handleChange}>
                                    <option value="1">Reconocimiento Facial</option>
                                    <option value="2">Reconocimiento Dactilar</option>
                                </select>
                            </div>
                            <div onClick={selectedOption == '1' ? handleClick01 : handleClick03}>
                                <button className="action-button">Validar Información</button>
                            </div>
                            <div onClick={handleClick02}>
                                <button className="action-button">Generar Reporte</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default SellerInfo;




